import React, { useState } from 'react';
import { Card, CardContent, Typography, Button, Divider, Table, TableBody, TableCell, TableHead, TableRow, Paper, Chip } from '@material-ui/core';
import AutocompleteAsyncrono from '../../../../components/Autocomplete';
import Http from '../../../../Http';
import Toast from 'react-hot-toast';

export default function TestEvaluador() {
  const [guiaSeleccionada, setGuiaSeleccionada] = useState('');
  const [opcionesFolio, setOpcionesFolio] = useState([]);
  const [dataSimulacion, setDataSimulacion] = useState(null);
  const [loading, setLoading] = useState(false);

  const evaluar = async () => {
    if (!guiaSeleccionada) {
      Toast.error('Seleccione una guía primero');
      return;
    }

    setLoading(true);
    try {
      const res = await Http.post('pago-transportista-reglas/test-evaluacion', { id_guia: guiaSeleccionada });
      if (res && res.data) {
        setDataSimulacion(res.data);
      } else {
        Toast.error(res?.errMsg || 'Error al evaluar guía');
      }
    } catch (e) {
      console.error(e);
      Toast.error('Error al evaluar la guía');
    } finally {
      setLoading(false);
    }
  };

  const fmtMoneda = (val) => new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(val || 0);

  return (
    <div style={{ padding: 20 }}>
      <Typography variant="h4" gutterBottom>Probar Motor de Reglas (Simulador)</Typography>
      <Card style={{ marginBottom: 20 }}>
        <CardContent>
          <div style={{ display: 'flex', gap: 20, alignItems: 'center' }}>
            <div style={{ flex: 1, maxWidth: 400 }}>
              <AutocompleteAsyncrono
                label="Buscar Guía (Folio)"
                apiUrl="search/guia-all"
                value={guiaSeleccionada}
                options={opcionesFolio}
                onOptionsChange={setOpcionesFolio}
                onChange={(e) => {
                  setGuiaSeleccionada(e.target.value);
                  setDataSimulacion(null);
                }}
              />
            </div>
            <Button
              variant="contained"
              color="primary"
              onClick={evaluar}
              disabled={!guiaSeleccionada || loading}
            >
              {loading ? 'Evaluando...' : 'Evaluar Guía'}
            </Button>
          </div>
        </CardContent>
      </Card>

      {dataSimulacion && (
        <div style={{ display: 'flex', gap: 20, flexWrap: 'wrap' }}>
          
          {/* Columna Izquierda: Datos de la Guía */}
          <div style={{ flex: '1 1 500px' }}>
            <Card style={{ height: '100%' }}>
              <CardContent>
                <Typography variant="h6" color="primary">JSON Inicial (Datos Guía)</Typography>
                <Divider style={{ margin: '10px 0' }} />
                
                <Table size="small" component={Paper} elevation={0} style={{ border: '1px solid #e0e0e0', marginBottom: 15 }}>
                  <TableBody>
                    <TableRow><TableCell><strong>ID Cliente</strong></TableCell><TableCell>{dataSimulacion.guiaData.id_cliente}</TableCell></TableRow>
                    <TableRow><TableCell><strong>KM Entrega</strong></TableCell><TableCell>{dataSimulacion.guiaData.km_entrega}</TableCell></TableRow>
                    <TableRow><TableCell><strong>Chofer (Unidad)</strong></TableCell><TableCell>{dataSimulacion.guiaData.id_chofer}</TableCell></TableRow>
                    <TableRow><TableCell><strong>Transportista</strong></TableCell><TableCell>{dataSimulacion.guiaData.id_transportista}</TableCell></TableRow>
                    <TableRow><TableCell><strong>Piezas Totales</strong></TableCell><TableCell>{dataSimulacion.guiaData.piezas_totales}</TableCell></TableRow>
                    <TableRow><TableCell><strong>Peso Total</strong></TableCell><TableCell>{dataSimulacion.guiaData.peso_total} kg</TableCell></TableRow>
                    <TableRow><TableCell><strong>Sucursal Destino</strong></TableCell><TableCell>{dataSimulacion.guiaData.id_sucursal_destino}</TableCell></TableRow>
                    <TableRow><TableCell><strong>Zona Destino</strong></TableCell><TableCell>{dataSimulacion.guiaData.id_zona_destino}</TableCell></TableRow>
                    <TableRow><TableCell><strong>Total Guía</strong></TableCell><TableCell>{fmtMoneda(dataSimulacion.guiaData.total_guia)}</TableCell></TableRow>
                    <TableRow><TableCell><strong>Subtotal Guía</strong></TableCell><TableCell>{fmtMoneda(dataSimulacion.guiaData.subtotal_guia)}</TableCell></TableRow>
                    <TableRow><TableCell><strong>Costo Flete</strong></TableCell><TableCell>{fmtMoneda(dataSimulacion.guiaData.valor_flete)}</TableCell></TableRow>
                    <TableRow><TableCell><strong>Costo Entrega</strong></TableCell><TableCell>{fmtMoneda(dataSimulacion.guiaData.entrega_guia)}</TableCell></TableRow>
                    <TableRow><TableCell><strong>Fecha Guía</strong></TableCell><TableCell>{dataSimulacion.guiaData.fecha_guia}</TableCell></TableRow>
                    <TableRow><TableCell><strong>Hora Guía</strong></TableCell><TableCell>{dataSimulacion.guiaData.hora_guia}</TableCell></TableRow>
                  </TableBody>
                </Table>

                <Typography variant="subtitle2">Autoservicios</Typography>
                <div style={{ display: 'flex', gap: 10, margin: '10px 0' }}>
                  <Chip label="Normal" color={dataSimulacion.guiaData.es_autoservicio_normal ? 'primary' : 'default'} size="small" />
                  <Chip label="Nocturno" color={dataSimulacion.guiaData.es_autoservicio_nocturno ? 'primary' : 'default'} size="small" />
                  <Chip label="Días Festivos" color={dataSimulacion.guiaData.es_autoservicio_dias_festivos ? 'primary' : 'default'} size="small" />
                </div>

                <Typography variant="subtitle2" style={{ marginTop: 15 }}>Líneas de Paquete (Embalajes)</Typography>
                {dataSimulacion.guiaData.paquetes && dataSimulacion.guiaData.paquetes.length > 0 ? (
                  <Table size="small" component={Paper} elevation={0} style={{ border: '1px solid #e0e0e0', marginTop: 5 }}>
                    <TableHead>
                      <TableRow>
                        <TableCell>ID Embalaje</TableCell>
                        <TableCell>Piezas</TableCell>
                        <TableCell>Peso</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {dataSimulacion.guiaData.paquetes.map((p, i) => (
                        <TableRow key={i}>
                          <TableCell>{p.id_embalaje}</TableCell>
                          <TableCell>{p.piezas}</TableCell>
                          <TableCell>{p.peso} kg</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                ) : (
                  <Typography variant="body2" color="textSecondary">Sin paquetes registrados.</Typography>
                )}

              </CardContent>
            </Card>
          </div>

          {/* Columna Derecha: Resultado Evaluación */}
          <div style={{ flex: '1 1 500px' }}>
            <Card style={{ height: '100%', background: dataSimulacion.evaluacion.matched ? '#f1f8e9' : '#fafafa' }}>
              <CardContent>
                <Typography variant="h6" color={dataSimulacion.evaluacion.matched ? 'primary' : 'secondary'}>
                  Resultado de Evaluación
                </Typography>
                <Divider style={{ margin: '10px 0' }} />

                {dataSimulacion.evaluacion.matched ? (
                  <>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                      <Typography variant="h5">Total a Pagar:</Typography>
                      <Typography variant="h4" color="primary" style={{ fontWeight: 'bold' }}>
                        {fmtMoneda(dataSimulacion.evaluacion.pago)}
                      </Typography>
                    </div>

                    <Typography variant="subtitle1" gutterBottom style={{ fontWeight: 'bold' }}>Grupo Ganador:</Typography>
                    <Typography variant="body1" gutterBottom>
                      {dataSimulacion.evaluacion.grupo?.nombre_grupo || 'Sin Nombre'} (ID: {dataSimulacion.evaluacion.grupo?.id})
                    </Typography>

                    <Typography variant="subtitle1" gutterBottom style={{ fontWeight: 'bold', marginTop: 15 }}>Tipo de Evaluación:</Typography>
                    <Chip label={dataSimulacion.evaluacion.tipo_evaluacion === 'guia' ? 'Por Guía Global' : 'Por Línea de Embalaje'} color="secondary" />

                    {dataSimulacion.evaluacion.tipo_evaluacion === 'guia' && dataSimulacion.evaluacion.subgrupo && (
                       <div style={{ marginTop: 20, padding: 15, background: '#fff', border: '1px solid #ddd', borderRadius: 8 }}>
                          <Typography variant="subtitle2" gutterBottom>Detalle del Subgrupo Aplicado</Typography>
                          <Typography variant="body2">• ID Subgrupo: {dataSimulacion.evaluacion.subgrupo.id}</Typography>
                          <Typography variant="body2">• Tipo de Pago: {dataSimulacion.evaluacion.subgrupo.tipo_pago}</Typography>
                          <Typography variant="body2">• Valor Configurador: {dataSimulacion.evaluacion.subgrupo.valor_pago}</Typography>
                          <Typography variant="body2">• Lógica de Condiciones: {dataSimulacion.evaluacion.subgrupo.condicion}</Typography>
                       </div>
                    )}

                    {dataSimulacion.evaluacion.tipo_evaluacion === 'embalaje' && dataSimulacion.evaluacion.subgrupos_matched && (
                       <div style={{ marginTop: 20 }}>
                          <Typography variant="subtitle2" gutterBottom>Líneas de Paquete que Cumplieron Reglas:</Typography>
                          <Table size="small" component={Paper} elevation={0} style={{ border: '1px solid #ccc' }}>
                            <TableHead>
                              <TableRow>
                                <TableCell>Línea #</TableCell>
                                <TableCell>ID Subgrupo</TableCell>
                                <TableCell>Cálculo</TableCell>
                                <TableCell align="right">Subtotal</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {dataSimulacion.evaluacion.subgrupos_matched.map((match, idx) => (
                                <TableRow key={idx}>
                                  <TableCell>{match.paquete_index + 1}</TableCell>
                                  <TableCell>{match.id}</TableCell>
                                  <TableCell>{match.tipo_pago} de {match.valor_pago}</TableCell>
                                  <TableCell align="right">{fmtMoneda(match.pago_linea)}</TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                       </div>
                    )}

                  </>
                ) : (
                  <div style={{ textAlign: 'center', padding: '40px 0' }}>
                    <Typography variant="h6" color="textSecondary">Ninguna regla coincidió con esta guía.</Typography>
                    <Typography variant="h3" color="textSecondary" style={{ marginTop: 10 }}>$0.00</Typography>
                  </div>
                )}
              </CardContent>
            </Card>
          </div>

        </div>
      )}

    </div>
  );
}
